import React, { useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';

const DateRange = ({columnKey, label, filters, setFilter}) => {
  const columnFilter = filters[columnKey] || [];

  const [fromDate, setFromDate] = useState(columnFilter[0]);
  const [toDate, setToDate] = useState(columnFilter[1]);

  if ('undefined' === typeof filters[columnKey]) {
    setFilter(columnKey, null);
    if (fromDate) { setFromDate(undefined) };
    if (toDate) { setToDate(undefined) };
  }

  const updateFilter = () => {
    if (
      fromDate && !isNaN(Date.parse(fromDate)) && Date.parse(fromDate) > 0 &&
      toDate && !isNaN(Date.parse(toDate)) && Date.parse(toDate) > 0
    ) {
      setFilter(columnKey, [fromDate, toDate]);
    }
  }

  const updateFromDate = value => {
    setFromDate(value);
    updateFilter();
  };

  const updateToDate = value => {
    setToDate(value);
    updateFilter();
  };

  return (
    <>
      <Form.Label>{label}:</Form.Label>
      <Row key={columnKey}
        style={{display: 'flex', flexDirection: 'row', gap: '50px',
          marginLeft: '20px'
        }}
      >
        <Col style={{display: 'flex', gap: '10px'}}>
          From
          <Form.Control
            type="date"
            value={fromDate || ''}
            onBlur={event => updateFromDate(event.currentTarget.value)}
            onChange={event => updateFromDate(event.currentTarget.value)}
          />
        </Col>
        <Col style={{display: 'flex', gap: '10px'}}>
          To
          <Form.Control
            type="date"
            value={toDate || ''}
            onBlur={event => updateToDate(event.currentTarget.value)}
            onChange={event => updateToDate(event.currentTarget.value)}
          />
        </Col>
      </Row>
    </>
  );
};

export default DateRange;
